import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const propTypes = {
    /**
   * The layout of the form. Use horizontal when your form uses the label to the left of the input, instead of above it
   */ variant: PropTypes.oneOf([
        'vertical',
        'horizontal'
    ]),
    /**
   * The skin for the form. Tight will reduce margin between inputs
   */ skin: PropTypes.oneOf([
        'standard',
        'tight'
    ])
};
const StandardForm = createComponent({
    displayName: 'StandardForm',
    root: 'form',
    propTypes,
    propConfig: {
        classNames (props) {
            const classes = new Set([
                'swan-form'
            ]);
            if (props.variant === 'horizontal') classes.add('swan-form-horizontal');
            if (props.skin === 'tight') classes.add('swan-form-skin-tight');
            return classes;
        },
        processProps (props) {
            const finalProps = _object_spread({}, props);
            // if there is no method or action or onSubmit, prevent the submission
            if (!props.onSubmit && !props.method && !props.action) {
                finalProps.onSubmit = (e)=>{
                    e.preventDefault();
                };
            }
            return finalProps;
        }
    }
});
StandardForm.defaultProps = {
    variant: 'vertical',
    skin: 'standard'
};

export { StandardForm };
